import { createSlice } from '@reduxjs/toolkit';
import { getAboutUsInfo } from 'reduxStore/actions/AboutUs';
import { getContactInfo } from 'reduxStore/actions/contactUs';

const initialState = {
  userLoading: false,
  contactDetails: [],
  error: null,
};

const contactSlice = createSlice({
  name: 'contactUs',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getContactInfo.fulfilled, (state, action) => {
        state.contactDetails = action.payload;
        state.userLoading = false;
      })
      .addCase(getContactInfo.pending, (state) => {
        state.userLoading = true;
      })
      .addCase(getContactInfo.rejected, (state, action) => {
        state.userLoading = false;
        state.error = action.payload;
      });
  },
});

export default contactSlice.reducer;
